import { customStyles } from '../../styles/customStyles';

const EditorSection = () => {
  return (
    <section className="py-24 bg-[#D1D1C9]/20 relative">
      <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row gap-16">
        <div className="w-full lg:w-1/3">
          <div className="sticky top-24">
            <h2 className="font-serif-display text-5xl lg:text-6xl mb-6">Редактируйте за <span className="bg-[#b7eb6f] px-2">30 секунд</span></h2>
            <p className="font-sans text-lg opacity-80 mb-8">
              Если что-то не понравилось — не нужно ждать дизайнера. Правки занимают секунды.
            </p>

            <div className="space-y-4 font-typewriter text-sm">
              <div className="flex items-center gap-4 p-3 bg-white border border-[#1F1F1F]/5 rounded shadow-sm hover:translate-x-2 transition-transform cursor-pointer">
                <i className="ph ph-text-t text-xl text-[#b7eb6f]"></i>
                <span>Изменить текст</span>
              </div>
              <div className="flex items-center gap-4 p-3 bg-white border border-[#1F1F1F]/5 rounded shadow-sm hover:translate-x-2 transition-transform cursor-pointer">
                <i className="ph ph-paint-bucket text-xl text-[#b7eb6f]"></i>
                <span>Сменить цвет</span>
              </div>
              <div className="flex items-center gap-4 p-3 bg-white border border-[#1F1F1F]/5 rounded shadow-sm hover:translate-x-2 transition-transform cursor-pointer">
                <i className="ph ph-arrows-out-cardinal text-xl text-[#b7eb6f]"></i>
                <span>Перестроить блок</span>
              </div>
            </div>

            <div className="mt-12">
              <h4 className="font-serif-display text-xl italic mb-4">Это снимает:</h4>
              <ul className="space-y-2 text-sm opacity-70 list-disc pl-4">
                <li>Зависимость от исполнителей</li>
                <li>Задержки по срокам</li>
                <li>Переплаты за каждую правку</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-2/3">
          <div className="bg-[#1E1E1E] rounded-xl p-2 shadow-2xl" style={{ transform: 'rotate(1deg)', ...customStyles.paperCard }}>
            <div className="h-10 bg-[#2A2A2A] rounded-t-lg flex items-center px-4 gap-2 border-b border-white/10">
              <div className="w-3 h-3 rounded-full bg-red-500"></div>
              <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
              <div className="w-3 h-3 rounded-full bg-green-500"></div>
              <div className="ml-auto text-white/30 font-typewriter text-xs">Editor v2.0</div>
            </div>
            <div className="bg-[#1E1E1E] p-8 h-[500px] relative overflow-hidden flex items-center justify-center">
              <video 
                autoPlay 
                loop 
                muted 
                playsInline
                className="w-full h-full object-contain rounded"
                style={{ maxHeight: '480px' }}
              >
                <source src="/stil/0223-2.mp4" type="video/mp4" />
                Ваш браузер не поддерживает видео.
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditorSection;
